<form [formGroup]="form" class="w-full" (ngSubmit)="onSubmit()">
  <button
    mat-button
    type="button"
    class="qaroni-close-icon"
    [mat-dialog-close]="false">
    <mat-icon>close</mat-icon>
  </button>
  <div class="mat-mdc-dialog-title" i18n>Nuevo Comentario</div>
  <mat-dialog-content>
    <div class="flex w-full flex-col gap-1">
      @if (showEmployeesList) {
        <div class="w-full">
          <mat-form-field appearance="outline" class="w-full">
            <mat-label i18n>Evaluados</mat-label>
            <mat-select formControlName="employeeId">
              @for (employee of employeesList; track employee.employeeId) {
                <mat-option [value]="employee.employeeId">
                  {{ employee.employee }}
                </mat-option>
              }
            </mat-select>
            @if (InputValidation.checkInputErrors(employeeId)) {
              <mat-error align="start">
                <qaroni-input-error-messages [fc]="employeeId" />
              </mat-error>
            }
          </mat-form-field>
        </div>
      }
      <div class="w-full">
        <mat-form-field appearance="outline" hideRequiredMarker>
          <mat-label i18n>Comentario</mat-label>
          <textarea
            matInput
            row="3"
            formControlName="message"
            autocomplete="off"
            class="resize-none"
            type="text"></textarea>
          @if (InputValidation.checkInputErrors(message)) {
            <mat-error align="start">
              <qaroni-input-error-messages [fc]="message" />
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <div class="flex items-center justify-center gap-2">
      <button
        mat-flat-button
        color="light-blue"
        class="qaroni-rounded-button"
        type="button"
        [mat-dialog-close]="false"
        i18n>
        Cancelar
      </button>
      <button
        mat-flat-button
        color="blue"
        class="qaroni-rounded-button"
        type="submit">
        <mat-icon class="mr-1">save</mat-icon>
        <ng-container i18n>Guardar</ng-container>
      </button>
    </div>
  </mat-dialog-actions>
</form>
